import AttachmentsList from 'components/AttachmentsList'
import React from 'react'
import { restrictiveListTypes } from 'utils/constants/DueDiligenceRelations'

import styles from './styles'
import DisplayAnswerItems from './DisplayAnswerItems'

function DisplayRestrictiveLists(props) {
  const { questionData } = props
  const classes = styles()

  const buildRestrictiveList = (activityInfo) => {
    return (
      <div className={classes.answersContainer} key={activityInfo.key}>
        <p>
          <span>Lista restritiva: </span>
          {activityInfo.restriction_type === 'other'
            ? activityInfo.other_restrictions
            : restrictiveListTypes[activityInfo.restriction_type]}
        </p>
        <p>
          <span>Número do processo: </span>
          {activityInfo.process_number}
        </p>
        {activityInfo.attachments.length > 0 ? (
          <AttachmentsList attachments={activityInfo.attachments} />
        ) : null}
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <h3>Detalhamento das listas restritivas:</h3>
      <DisplayAnswerItems
        answerData={questionData}
        noDataMessage="O assessor informou que não consta em nenhuma lista restritiva."
        funcBuildItem={buildRestrictiveList}
      />

    </div>
  )
}

export default DisplayRestrictiveLists
